module.exports = __webpack_public_path__ + "static/point-cross-14373f2883b4d266646a11fd4796f8ed.png";